export const roles = [
    {"label": "数据录入员","type":"edit", "value": "1047799163079327744"},
    {"label": "数据审核员","type":"check", "value": "1047799232980291584"},
    {"label": "数据维护员","type":"editor", "value": "1048737717963972608"},
    {"label": "保险公司","type":"ic", "value": "1056789942370549760"},
    {"label": "服务机构","type":"so", "value": "1056789996395966464"},
    {"label": "企业管理","type":"ep", "value": "1056790076746706944"},
    {"label": "系统管理","type":"sys", "value": "1056790147900440576"}
]



// WEBPACK FOOTER //
// ./src/assets/json/data.js